import { useGroupeForm } from "../hooks/use-groupe-form";
import { EditGroupeFormFields } from "./edit-groupe-form-fields";
import { useUpdateGroupeSubscription } from "@repo/ui/hooks/api/groupes/use-groupe-usage";

interface EditGroupeFormProps {
  groupeId: number;
  onCancel: () => void;
  onSuccess: () => void;
}

export function EditGroupeForm({ groupeId, onCancel, onSuccess }: EditGroupeFormProps) {
  const updateSubscription = useUpdateGroupeSubscription();

  const {
    formData,
    error,
    isLoading,
    isPending,
    subscriptionConfig,
    selectedPlanType,
    selectedTierId,
    handleInputChange,
    handleSelectChange,
    handleSubmit,
    handlePlanSelect,
  } = useGroupeForm({ groupeId, onSuccess });

  const handleSubscriptionUpdate = async () => {
    if (!groupeId) return;

    try {
      await updateSubscription.mutateAsync({
        id: groupeId,
        data: {
          max_parcours_per_month: (formData as any).max_parcours_per_month,
          current_month_parcours: (formData as any).current_month_parcours,
          plan_type: selectedPlanType,
          subscription_status: (formData as any).subscription_status,
          tier_id: selectedTierId,
        }
      });
    } catch (error) {
      console.error('Failed to update subscription:', error);
    }
  };

  if (isLoading) {
    return <div className="flex justify-center p-4">Chargement des données...</div>;
  }

  return (
    <EditGroupeFormFields
      formData={formData}
      error={error}
      isPending={isPending}
      subscriptionConfig={subscriptionConfig}
      selectedPlanType={selectedPlanType}
      selectedTierId={selectedTierId}
      groupeId={groupeId}
      isUpdatingSubscription={updateSubscription.isPending}
      onCancel={onCancel}
      handleInputChange={handleInputChange}
      handleSelectChange={handleSelectChange}
      handleSubmit={handleSubmit}
      handlePlanSelect={handlePlanSelect}
      handleSubscriptionUpdate={handleSubscriptionUpdate}
    />
  );
}
